/* assets/vh-hd2.js — WP-P40 W7, r3. NUR fuer die eigenen Mega-Panels (Desktop-Nav-Dropdowns) und
   das Akkordeon im mobilen Drawer-Inhalt. Suche, Konto, Warenkorb, Drawer-Oeffnen/-Schliessen sind
   native Theme-Mechanik (section-header.js/component-predictive-search.js/component-sidebar-Custom-
   Elements) und werden von dieser Datei NICHT beruehrt. */
(function () {
  "use strict";

  function onReady(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  onReady(function () {
    /* ---------- Desktop Mega-Panels ---------- */
    var nav = document.querySelector("[data-vh-hd2-nav]");
    if (nav) {
      var triggers = nav.querySelectorAll("[data-vh-hd2-trigger]");
      var isTouch = matchMedia("(hover: none), (pointer: coarse)").matches;
      var openTimer = null, closeTimer = null;

      function openPanel(trigger) {
        clearTimeout(closeTimer);
        triggers.forEach(function (t) {
          if (t === trigger) return;
          t.setAttribute("aria-expanded", "false");
          t.closest(".vh-hd2-nav__item").removeAttribute("data-open");
          var p = document.getElementById(t.getAttribute("aria-controls"));
          if (p) p.hidden = true;
        });
        var panel = document.getElementById(trigger.getAttribute("aria-controls"));
        trigger.setAttribute("aria-expanded", "true");
        trigger.closest(".vh-hd2-nav__item").setAttribute("data-open", "true");
        if (panel) panel.hidden = false;
      }

      function closeAll() {
        triggers.forEach(function (t) {
          t.setAttribute("aria-expanded", "false");
          t.closest(".vh-hd2-nav__item").removeAttribute("data-open");
          var p = document.getElementById(t.getAttribute("aria-controls"));
          if (p) p.hidden = true;
        });
      }

      triggers.forEach(function (trigger) {
        var item = trigger.closest(".vh-hd2-nav__item");

        /* Klick/Tastatur: immer verfuegbar (auch auf Touch-Geraeten als Tap) */
        trigger.addEventListener("click", function () {
          var isOpen = trigger.getAttribute("aria-expanded") === "true";
          clearTimeout(openTimer); clearTimeout(closeTimer);
          if (isOpen) closeAll(); else openPanel(trigger);
        });

        if (!isTouch) {
          /* Hover: ~120ms Oeffnungs-, ~250ms Schliessverzoegerung (Inhaber-Auftrag r4). Auf item
             UND panel gebunden (panel ist absolut positioniert mit Luecke zum Trigger -- ohne
             eigenen Handler wuerde die Luecke die Schliess-Verzoegerung faelschlich abbrechen). */
          var panelEl = document.getElementById(trigger.getAttribute("aria-controls"));
          [item, panelEl].forEach(function (el) {
            if (!el) return;
            el.addEventListener("mouseenter", function () {
              clearTimeout(closeTimer); clearTimeout(openTimer);
              openTimer = setTimeout(function () { openPanel(trigger); }, 120);
            });
            el.addEventListener("mouseleave", function () {
              clearTimeout(openTimer);
              closeTimer = setTimeout(closeAll, 250);
            });
          });
        }
      });

      document.addEventListener("click", function (e) {
        if (!nav.contains(e.target)) closeAll();
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") closeAll();
      });
    }

    /* ---------- Suche < 1024px: Icon oeffnet das Feld als Ueberlagerung ---------- */
    var searchWrap = document.querySelector(".vh-hd2-search");
    if (searchWrap) {
      var searchIcon = searchWrap.querySelector(".vh-hd2-search__icon");
      var searchInput = searchWrap.querySelector("input[data-js-search-input]");
      if (searchIcon) {
        searchIcon.addEventListener("click", function () {
          if (window.matchMedia("(min-width: 1024px)").matches) return;
          var opening = !searchWrap.classList.contains("is-open");
          searchWrap.classList.toggle("is-open");
          if (opening && searchInput) searchInput.focus();
        });
      }
      document.addEventListener("click", function (e) {
        if (!searchWrap.contains(e.target)) searchWrap.classList.remove("is-open");
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") searchWrap.classList.remove("is-open");
      });
    }

    /* ---------- Mobiler Drawer: Akkordeon (native sidebar-drawer bleibt fuer Auf/Zu zustaendig) ---------- */
    /* r10: sanfte Animation statt hartem hidden-Umschalten -- max-height auf scrollHeight setzen
       (CSS transitioniert), danach auf "auto" wechseln, damit ein spaeterer Inhaltswechsel (z. B.
       Fenster-Resize) nicht abgeschnitten bleibt. */
    var accordions = document.querySelectorAll("[data-vh-hd2-accordion]");
    accordions.forEach(function (btn) {
      var panel = document.getElementById(btn.getAttribute("aria-controls"));
      if (!panel) return;
      btn.addEventListener("click", function () {
        var isOpen = btn.getAttribute("aria-expanded") === "true";
        btn.setAttribute("aria-expanded", String(!isOpen));
        if (isOpen) {
          panel.style.maxHeight = panel.scrollHeight + "px";
          requestAnimationFrame(function () {
            panel.classList.remove("is-open");
            panel.style.maxHeight = "0px";
          });
        } else {
          panel.classList.add("is-open");
          panel.style.maxHeight = panel.scrollHeight + "px";
          panel.addEventListener("transitionend", function onEnd() {
            panel.style.maxHeight = "none";
            panel.removeEventListener("transitionend", onEnd);
          });
        }
      });
    });
  });
})();
